import clsx from "clsx";
import { useEffect, useState } from "react";

type Props = {
    value?: boolean;
    reject?: boolean;
    onClick?: Function;
}


const CheckAtomComponent = ({ value, reject, onClick }: Props) => {
    let [status, setStatus] = useState(value ?? false);

    useEffect(() => {
        setStatus(value ?? false);
    }, [value]);

    const handleAction = () => {
        if(!onClick)
            return;
        if(!!value) setStatus((prev) => !prev);
        onClick(value ?? status);
    }

    return (
        <div className={clsx('check-item', !!onClick && 'selector', status ? 'active': reject ? 'reject': '' )} onClick={handleAction}>
            {status ? (
                <i className="bi bi-check-lg"></i>
            ) : reject ? (
                <i className="bi bi-x-lg"></i>
            ) : null}
        </div>
    )
};

export default CheckAtomComponent;